module.exports = __webpack_public_path__ + "static/media/check.7d94e28e.svg";